export const GLOBAL_RA_WIDTH = 428;
